import React, { useEffect, useRef, useState } from "react";
import "../../../scss/SignUp.scss";
import { Link, useNavigate } from "react-router-dom";
import { customMessage, encrypt, showToastTR } from "../../../Utils/BaseApp";
import * as DomicilappService from "../../../services/DomicilappService";
import { SingUpModel } from "../../../models/SignUp";
import "react-toastify/dist/ReactToastify.css";
import { Form, Modal } from "react-bootstrap";
import {
  CButton,
  CCol,
  CContainer,
  CForm,
  CFormCheck,
  CFormInput,
  CFormSelect,
  CImage,
  CLoadingButton,
  CRow,
} from "@coreui/react-pro";
import logoFull from "../../../assets/icons/logo-full.png";
import { useAppDispatch } from "../../../hooks/hooks";
import { startLoading, stopLoading } from "../../../redux/features/loadSlice";
import { env } from "../../../Utils/Environment";
import { useSeo } from "../../../hooks/useSeo";

export interface SignUpProps { }

export const SignUp: React.FC<SignUpProps> = ({ }: SignUpProps) => {
  useSeo({
    title: "Registra tu negocio gratis | DomicilApp",
    description: "Crea la cuenta de tu negocio en DomicilApp y empieza a recibir pedidos a domicilio y para recoger en tienda de los clientes de tu ciudad.",
    index: true,
  });
  const [passwordError, setPasswordError] = useState<string | null>(null);
  const [verifyPolicy, setVerifyPolicy] = useState<boolean>(false);
  const [formError, setFormError] = useState(false);
  const [signUp, setSignUp] = useState<SingUpModel | null>(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  // Estados para Departamentos y Municipios
  const [departments, setDepartments] = useState<any[]>([]);
  const [municipalities, setMunicipalities] = useState<any[]>([]);

  const [minutos, setMinutos] = useState(2);
  const [segundos, setSegundos] = useState(0);
  const [corriendo, setCorriendo] = useState(false);
  const dispatch = useAppDispatch();

  // Estado del Formulario
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    email: "",
    department_id: "",
    municipality_id: "",
    password: "",
    repeat_password: "",
    referral_code: "",
  });

  // Carga inicial de departamentos (Ejemplo / Integrar con tu servicio)
  useEffect(() => {
    loadDepartments();
  }, []);

  const loadDepartments = async () => {
    try {
      // Reemplazar con la llamada a tu API: const res = await DomicilappService.getDepartments();
      // setDepartments(res.data);
    } catch (error) {
      console.error("Error al cargar departamentos:", error);
    }
  };

  const handleDepartmentChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const deptId = e.target.value;
    setFormData({ ...formData, department_id: deptId, municipality_id: "" });

    // Filtrar/Cargar municipios según el departamento seleccionado
    if (deptId) {
      // Reemplazar con tu servicio: const res = await DomicilappService.getMunicipalities(deptId);
      // setMunicipalities(res.data);
    } else {
      setMunicipalities([]);
    }
  };

  useEffect(() => {
    var intervalo: any;
    if (corriendo) {
      intervalo = setInterval(() => {
        if (segundos === 0) {
          if (minutos === 0) {
            clearInterval(intervalo);
            setCorriendo(false);
          } else {
            setMinutos(minutos - 1);
            setSegundos(59);
          }
        } else {
          setSegundos(segundos - 1);
        }
      }, 1000);
    }
    return () => clearInterval(intervalo);
  }, [minutos, segundos, corriendo]);

  useEffect(() => {
    if (signUp) {
      if (signUp.status === 200) {
        showToastTR(customMessage(signUp.code_app), 500, "success");
        sendCode();
        setTimeout(() => {
          showToastTR("Enviando código de verificación", 1000, "info");
          setShowModal(true);
        }, 2000);
      } else {
        showToastTR(customMessage(signUp.code_app), 2000, "error");
      }
    }
  }, [signUp]);

  async function sendCode() {
    dispatch(startLoading());
    const body = {
      recipient: formData.email,
      send_method: "email",
      code_motive: "register_user",
    };
    await DomicilappService.sendCode(body);
    dispatch(stopLoading());
    setMinutos(2);
    setSegundos(0);
    setCorriendo(true);
  }

  async function verificationCode(code: number) {
    const body = {
      recipient: formData.email,
      send_method: "email",
      code_motive: "register_user",
      verification_code: code,
    };
    const response = await DomicilappService.verificationCode(body);

    if (response.status === 200) {
      showToastTR(customMessage(response.code_app), 500, "success");
      setShowModal(false);
      setTimeout(() => {
        navigate("/login");
      }, 1000);
    } else {
      showToastTR(customMessage(response.code_app), 2000, "error");
      clearFields();
    }
  }

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    var { name, value } = event.target;

    if (name === "phone_number") {
      value = value.replace(/\D/g, "");
      if (value.length > 3) value = `${value.slice(0, 3)} ${value.slice(3)}`;
      if (value.length > 7) value = `${value.slice(0, 7)} ${value.slice(7)}`;
    }

    setFormData({ ...formData, [name]: value });

    if (
      (name === "password" &&
        formData.repeat_password !== "" &&
        formData.repeat_password !== value) ||
      (name === "repeat_password" && formData.password !== value)
    ) {
      setPasswordError("Las contraseñas no coinciden");
      setFormError(true);
    } else {
      setPasswordError(null);
    }
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    const form = event.currentTarget as HTMLFormElement;
    if (!form.checkValidity()) {
      form.reportValidity();
      setFormError(true);
      return;
    }

    if (passwordError) {
      showToastTR(
        "Verifica que las contraseñas coincidan para continuar",
        1000,
        "error"
      );
      form.reportValidity();
      setFormError(true);
      return;
    }

    try {
      const body = {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: await encrypt(formData.email),
        phone_number: await encrypt(formData.phone_number.replaceAll(" ", "")),
        password: await encrypt(formData.password),
        department_id: formData.department_id,
        municipality_id: formData.municipality_id,
        phone_area_code: 57,
        referral_code: formData.referral_code ? formData.referral_code.trim() : null,
      };

      const response = await DomicilappService.signUp(body);
      setSignUp(response);
    } catch (error) {
      console.error("Error al llamar a la API:", error);
    }
  };

  const code_1 = useRef<HTMLInputElement>(null);
  const code_2 = useRef<HTMLInputElement>(null);
  const code_3 = useRef<HTMLInputElement>(null);
  const code_4 = useRef<HTMLInputElement>(null);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    var { name, value } = event.target;
    if (value !== "") {
      if (name === "1") code_2.current?.focus();
      else if (name === "2") code_3.current?.focus();
      else if (name === "3") code_4.current?.focus();
      else if (name === "4") code_1.current?.focus();

      if (
        code_1.current?.value !== "" &&
        code_2.current?.value !== "" &&
        code_3.current?.value !== "" &&
        code_4.current?.value !== ""
      ) {
        var code = parseInt(
          code_1.current?.value +
          "" +
          code_2.current?.value +
          "" +
          code_3.current?.value +
          "" +
          code_4.current?.value
        );
        verificationCode(code);
      }
    }
  };

  const clearFields = () => {
    if (code_1.current) code_1.current.value = "";
    if (code_2.current) code_2.current.value = "";
    if (code_3.current) code_3.current.value = "";
    if (code_4.current) code_4.current.value = "";
  };

  return (
    <div className="login-wrapper min-vh-100 d-flex align-items-center justify-content-center bg-light py-4">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={11} lg={9} className="p-0">
            <div className="card-login border-0 shadow-lg rounded-4 overflow-hidden">
              <CRow className="g-0">
                {/* Lateral Izquierdo - Branding DomicilApp */}
                <CCol md={5} className="login-banner p-4 p-lg-5 d-flex flex-column justify-content-between text-white">
                  <div>
                    <Link to="/" className="d-inline-block bg-white bg-opacity-10 backdrop-blur p-2 rounded-3 mb-4">
                      <CImage src={logoFull} height={32} alt="DomicilApp Logo" className="rounded"
                      />
                    </Link>
                  </div>
                  <div className="my-auto py-4">
                    <span className="badge bg-white bg-opacity-20 text-black rounded-pill px-3 py-2 mb-3 fw-normal fs-7">
                      Únete a DomicilApp
                    </span>
                    <h2 className="fw-bold mb-2 display-6 text-white">Crea tu cuenta</h2>
                    <p className="text-white-50 fs-6">
                      Empieza a gestionar tu tienda, catálogo o pedidos de forma rápida y sencilla.
                    </p>
                  </div>
                  <div className="footer-brand pt-3 border-top border-white border-opacity-10 fs-7 text-white-50">
                    &copy; DomicilApp ·{" "}
                    <a href="https://www.domicilapp.com" className="text-white-50">www.domicilapp.com</a>
                  </div>
                </CCol>

                {/* Lateral Derecho - Formulario Completo */}
                <CCol md={7} className="bg-white p-4 p-lg-5 d-flex flex-column justify-content-center">
                  <div className="mb-4">
                    <h1 className="h3 fw-bold text-dark mb-1">Registra tu negocio</h1>
                    <p className="text-muted fs-7">Ingresa tus datos e información de ubicación</p>
                  </div>

                  <CForm
                    className="needs-validation"
                    noValidate
                    validated={formError}
                    onSubmit={handleSubmit}
                  >
                    <CRow className="g-3">
                      {/* Nombre y Apellido */}
                      <CCol md={6}>
                        <label className="form-label text-secondary fw-medium fs-7">Nombre</label>
                        <CFormInput
                          type="text"
                          name="first_name"
                          value={formData.first_name}
                          onChange={handleChange}
                          placeholder="Ej. Carlos"
                          className="custom-input py-2 px-3"
                          feedbackInvalid="Escribe un nombre válido."
                          required
                        />
                      </CCol>

                      <CCol md={6}>
                        <label className="form-label text-secondary fw-medium fs-7">Apellido</label>
                        <CFormInput
                          type="text"
                          name="last_name"
                          value={formData.last_name}
                          onChange={handleChange}
                          placeholder="Ej. Gómez"
                          className="custom-input py-2 px-3"
                        />
                      </CCol>

                      {/* Teléfono y Correo */}
                      <CCol md={6}>
                        <label className="form-label text-secondary fw-medium fs-7">Teléfono Celular</label>
                        <CFormInput
                          type="text"
                          name="phone_number"
                          maxLength={12}
                          value={formData.phone_number}
                          onChange={handleChange}
                          placeholder="300 000 0000"
                          className="custom-input py-2 px-3"
                          feedbackInvalid="Escribe un teléfono válido."
                          required
                        />
                      </CCol>

                      <CCol md={6}>
                        <label className="form-label text-secondary fw-medium fs-7">Correo Electrónico</label>
                        <CFormInput
                          type="email"
                          name="email"
                          placeholder="nombre@ejemplo.com"
                          value={formData.email}
                          onChange={handleChange}
                          className="custom-input py-2 px-3"
                          feedbackInvalid="Escribe un correo válido."
                          required
                        />
                      </CCol>

                      {/* Departamento y Municipio en el mismo Row */}
                      <CCol md={6}>
                        <label className="form-label text-secondary fw-medium fs-7">Departamento</label>
                        <CFormSelect
                          name="department_id"
                          value={formData.department_id}
                          onChange={handleDepartmentChange}
                          className="custom-input py-2 px-3"
                          required
                        >
                          <option value="">Selecciona...</option>
                          {departments.map((dept) => (
                            <option key={dept.id} value={dept.id}>
                              {dept.name}
                            </option>
                          ))}
                        </CFormSelect>
                      </CCol>

                      <CCol md={6}>
                        <label className="form-label text-secondary fw-medium fs-7">Municipio / Ciudad</label>
                        <CFormSelect
                          name="municipality_id"
                          value={formData.municipality_id}
                          onChange={handleChange}
                          className="custom-input py-2 px-3"
                          disabled={!formData.department_id}
                          required
                        >
                          <option value="">
                            {formData.department_id ? "Selecciona..." : "Elige depto primero"}
                          </option>
                          {municipalities.map((muni) => (
                            <option key={muni.id} value={muni.id}>
                              {muni.name}
                            </option>
                          ))}
                        </CFormSelect>
                      </CCol>

                      {/* Contraseñas */}
                      <CCol md={6}>
                        <label className="form-label text-secondary fw-medium fs-7">Contraseña</label>
                        <CFormInput
                          type="password"
                          name="password"
                          placeholder="••••••••"
                          value={formData.password}
                          onChange={handleChange}
                          className="custom-input py-2 px-3"
                          feedbackInvalid="Escribe una contraseña válida."
                          required
                        />
                      </CCol>

                      <CCol md={6}>
                        <label className="form-label text-secondary fw-medium fs-7">Confirmar Contraseña</label>
                        <CFormInput
                          type="password"
                          name="repeat_password"
                          placeholder="••••••••"
                          value={formData.repeat_password}
                          onChange={handleChange}
                          className={`custom-input py-2 px-3 ${passwordError ? "is-invalid" : ""}`}
                          feedbackInvalid={passwordError ?? "Confirma tu contraseña."}
                          required
                        />
                      </CCol>

                      {/* Código de Referido (Opcional) */}
                      <CCol md={12}>
                        <label className="form-label text-secondary fw-medium fs-7">
                          Código de Referido / Invitación <span className="text-muted fw-normal">(Opcional)</span>
                        </label>
                        <CFormInput
                          type="text"
                          name="referral_code"
                          placeholder="Ej. REF-1234 o BIENVENIDA2026"
                          value={formData.referral_code}
                          onChange={handleChange}
                          className="custom-input py-2 px-3 text-uppercase"
                        />
                      </CCol>
                    </CRow>

                    <div className="d-flex justify-content-between align-items-center mt-4 mb-4 fs-7">
                      <CFormCheck
                        id="checkSaveSource"
                        type="checkbox"
                        checked={verifyPolicy}
                        onChange={() => setVerifyPolicy(!verifyPolicy)}
                        required
                        label={
                          <span className="text-secondary">
                            Acepto los{" "}
                            <a
                              href={env("PUBLIC_URL") + "termsandconditions"}
                              target="_blank"
                              rel="noreferrer"
                              className="text-danger text-decoration-none fw-semibold"
                            >
                              Términos y condiciones
                            </a>{" "}
                            y la{" "}
                            <a
                              href={env("PUBLIC_URL") + "policyprivacy"}
                              target="_blank"
                              rel="noreferrer"
                              className="text-danger text-decoration-none fw-semibold"
                            >
                              Política de privacidad
                            </a>
                          </span>
                        }
                      />
                      <Link className="text-decoration-none fw-semibold text-danger ms-2" to="/login">
                        ¿Ya tienes cuenta?
                      </Link>
                    </div>

                    <CButton
                      type="submit"
                      className="btn-submit w-100 py-2 fw-semibold rounded-3 border-0"
                    >
                      Registrarme
                    </CButton>
                  </CForm>
                </CCol>
              </CRow>
            </div>
          </CCol>
        </CRow>

        {/* Modal de Verificación con PIN Code */}
        <Modal show={showModal} centered backdrop="static" className="border-0">
          <Modal.Body className="p-4 p-md-5 text-center rounded-4">
            <div className="badge bg-danger bg-opacity-10 text-danger rounded-circle p-3 mb-3">
              <i className="bi bi-shield-check fs-2"></i>
            </div>
            <h4 className="fw-bold text-dark mb-2">Código de Verificación</h4>
            <p className="text-muted fs-7 mb-4">
              Hemos enviado un código de 4 dígitos a tu correo:
              <br />
              <strong className="text-dark">{formData.email}</strong>
            </p>

            <div className="d-flex justify-content-center gap-2 my-4">
              {[code_1, code_2, code_3, code_4].map((ref, idx) => (
                <Form.Control
                  key={idx}
                  type="text"
                  maxLength={1}
                  name={`${idx + 1}`}
                  className="code-pin-input text-center fw-bold fs-3"
                  onChange={handleInputChange}
                  ref={ref}
                />
              ))}
            </div>

            <p className="text-muted fs-7 mb-3">
              Tiempo restante:{" "}
              <span className="fw-bold text-dark">
                {`${minutos.toString().padStart(2, "0")}:${segundos.toString().padStart(2, "0")}`}
              </span>
            </p>

            {!corriendo && (
              <CLoadingButton
                className="btn-submit py-2 px-4 rounded-3 text-white border-0"
                onClick={sendCode}
                timeout={2000}
              >
                Reenviar Código
              </CLoadingButton>
            )}
          </Modal.Body>
        </Modal>
      </CContainer>
    </div>
  );
};